export const MODEL_TYPE = {
    ENTERPRISE: 1,
    PARENT_COMPANY: 2,
    COMPANY: 3,
};

export const getCustomerDetails = () => {
    return JSON.parse(localStorage.getItem('user'));
};

export const getModelTypeId = () => {
    const val = sessionStorage.getItem('cp_modelTypeID');
    return val !== null ? Number(val) : null;
};

export const getEntityId = () => {
    const val = sessionStorage.getItem('cp_entityID');
    return val !== null ? Number(val) : null;
};

export const getParentCompanyId = () => {
    return getModelTypeId() === MODEL_TYPE.PARENT_COMPANY ? getEntityId() : null;
};

export const getCompanyId = () => {
    const user = getCustomerDetails();
    return user?.companyID ?? (getModelTypeId() === MODEL_TYPE.COMPANY ? getEntityId() : null);
};

export const getScopeParams = () => {
    const modelTypeId = getModelTypeId();
    const entityId = getEntityId();
    if (modelTypeId === MODEL_TYPE.ENTERPRISE) return { enterpriseId: entityId };
    if (modelTypeId === MODEL_TYPE.PARENT_COMPANY) return { parentCompanyId: entityId };
    if (modelTypeId === MODEL_TYPE.COMPANY) return { companyId: entityId };
    return {};
};

export const getModelTypeIdAndEntityId = () => ({ modelTypeID: getModelTypeId(), entityID: getEntityId() });
